/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_OfflineInputs */

const en_us2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: the workout is saved here and sent when you're back online.`)
};

const pt_br2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão: o treino fica salvo aqui e é enviado quando a conexão voltar.`)
};

const es_419_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión: el entrenamiento queda guardado aquí y se envía cuando vuelvas a tener conexión.`)
};

const pt_pt2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação: o treino fica guardado aqui e é enviado quando a ligação voltar.`)
};

const fr_fr2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne : la séance est enregistrée ici et sera envoyée à ton retour en ligne.`)
};

const de_de2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: Das Training wird hier gespeichert und gesendet, sobald du wieder online bist.`)
};

const it_it2_workout_quick_offline = /** @type {(inputs: Workout_Quick_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: l'allenamento resta salvato qui e viene inviato quando torni online.`)
};

/**
* | output |
* | --- |
* | "Offline: the workout is saved here and sent when you're back online." |
*
* @param {Workout_Quick_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_offline = /** @type {((inputs?: Workout_Quick_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_offline(inputs)
	if (locale === "es-419") return es_419_workout_quick_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_offline(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_offline(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_offline(inputs)
	return en_us2_workout_quick_offline(inputs)
});
export { workout_quick_offline as "workout-quick.offline" }